// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__ZPh48","burger":"styles_burger__h+1Zs"};